import React from "react";
import styled from "styled-components";

interface IProps {
	width?: number;
	height?: number;
	color?: string;
}

const SVG = styled.svg``;

export const IconFilter: React.FC<IProps> = ({color, ...rest}) => (
	<SVG viewBox="0 0 14 10" fill="none" {...rest}>
		<g transform="translate(-3.000000, -5.000000)" fill={color}>
			<path d="M11.5555517,12.6754417 L11.5555517,14.2105417 L8.44444833,14.2105417 L8.44444833,12.6754417 L11.5555517,12.6754417 Z M14.6666667,8.837715 L14.6666667,10.3728033 L5.33333333,10.3728033 L5.33333333,8.837715 L14.6666667,8.837715 Z M17,5 L17,6.53508833 L3,6.53508833 L3,5 L17,5 Z" />
		</g>
	</SVG>
);

IconFilter.defaultProps = {
	width: 14,
	height: 10,
	color: "currentColor",
};
